<size-indicator if={active()} class="d-flex align-items-end {props.class}">
  <div
    class="rect mr-3"
    style="width: {width()}px; height: {height()}px;"
  ></div>
  <svg
    height="{props.renderHeight}px"
    viewBox="0 0 48.68332 116.59056"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg">
    <path
      style="fill: currentColor"
      d="m 30.69355,116.192 c -1.2083,-0.52399 -2.03834,-1.31816 -2.73962,-2.62123 l -0.56956,-1.05833 0.081,-44.95821 c 0.0517,-28.661876 0.1749,-45.133623 0.34003,-45.442172 0.23514,-0.439359 0.66777,-0.483984 4.69204,-0.483984 4.98433,0 6.55361,0.285043 9.14943,1.6619 3.35257,1.77825 6.06561,5.51551 6.75183,9.30075 0.18141,1.00064 0.28462,7.03887 0.28462,16.651356 0,14.71288 -0.0134,15.10907 -0.54794,16.21331 -1.09618,2.2644 -4.01401,3.03137 -5.94095,1.56163 -1.9651,-1.49885 -1.85676,-0.50492 -1.74779,-16.03484 0.0715,-10.185836 0.0157,-14.078386 -0.20775,-14.495866 -0.33634,-0.62846 -1.06335,-0.74673 -1.55683,-0.25325 -0.24396,0.24396 -0.31785,9.023946 -0.31898,37.901566 -10e-4,25.40986 -0.0914,37.90779 -0.27902,38.58348 -0.81987,2.95235 -4.55003,4.70569 -7.39053,3.47389 z m -11.511251,-0.34071 c -1.25884,-0.57807 -1.82296,-1.16811 -2.371159,-2.48014 -0.35174,-0.84183 -0.40697,-3.2545 -0.40697,-17.77818 V 78.7888 l -5.4615,-0.0715 C 6.25102,78.6559 5.44316,78.58548 5.21156,78.218 c -0.20279,-0.32177 1.2492,-5.64635 5.85837,-21.48323 3.3704,-11.58049 6.127989,-21.351446 6.127989,-21.713236 0,-1.07125 -1.657439,-1.24551 -1.959289,-0.20599 -0.0701,0.24122 -1.75027,6.09404 -3.73383,13.006276 C 9.52125,54.73406 7.69879,60.73427 7.4549,61.15563 5.91421,63.81736 1.91166,63.76089 0.53273,61.05793 0.23973,60.4836 0,59.68051 0,59.27327 0,58.86603 1.76785,52.75934 3.92856,45.70283 6.08927,38.646334 8.0727,32.128544 8.33618,31.218864 c 0.99228,-3.42592 3.90425,-6.70191 7.53882,-8.481224 1.929399,-0.944541 2.080599,-0.974069 5.457469,-1.065699 3.382661,-0.09179 3.484281,-0.07827 3.902611,0.51897 0.39218,0.559913 0.42938,4.488573 0.42803,45.202769 -0.001,31.55124 -0.0864,44.89539 -0.29185,45.63548 -0.37133,1.33747 -1.688911,2.65505 -3.026381,3.02637 -1.42335,0.39517 -1.92819,0.36256 -3.16258,-0.20427 z m 4.45139,-97.234743 c -2.45324,-0.800772 -4.66457,-2.82335 -5.81958,-5.322848 -0.61449,-1.329796 -0.73136,-1.931106 -0.71995,-3.704166 0.0172,-2.673009 0.74052,-4.633249 2.38419,-6.461406 4.875571,-5.422807 13.811171,-3.49671202 16.127221,3.476271 0.62155,1.871308 0.41801,5.167974 -0.42935,6.953885 -0.80315,1.692753 -2.92173,3.812103 -4.61685,4.618542 -1.63031,0.775602 -5.20195,1.002372 -6.925681,0.439722 z"
    />
  </svg>

  <script>
    export default class {
      active() {
        if (!this.props.wh) return false

        return true
      }

      factor() {
        return this.props.renderHeight / this.props.refHeight
      }

      width() {
        if (!this.active()) return 0
        
        return this.props.wh[1] * this.factor()
      }

      height() {
        if (!this.active()) return 0

        return this.props.wh[0] * this.factor()
      }
    }
  </script>
</size-indicator>